import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../Auth/useCreateProductServiceAdminAxiosInstance.ts";

export function useKnownRefundAcTags(item: "products" | "bundles") {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const url = `/${item}/ac-tags/known-refund-tags`;
  const { data, isLoading } = useSWR(url, async (url) => {
    const { data } = await createAxiosInstance().get<string[]>(url);
    return data;
  });

  return {
    refundTags: data ?? [],
    isLoading,
  };
}
